import MessageHistoryRetentionNotice from './MessageHistoryRetentionNotice';

export default MessageHistoryRetentionNotice;
